<template>
  <section>
    <div class="main_wrap">
      <div class="service-qrcode">
        <div class="qrcode-wrap">
          <img :src="serviceQrcode">
        </div>
        <p>扫码添加客服微信</p>
      </div>
      <router-view></router-view>
    </div>

  </section>
</template>

<script>
import {useRouter, useRoute} from "vue-router";
import serviceQrcode from "@/assets/service-qrcode.jpg"
// 引入vue-router
export default {
  setup() {
    return {
      useRouter,
      useRoute,
      serviceQrcode
    };
  },
};
</script>
<style lang="scss" scoped>
.main_wrap {
  padding-bottom: 40px;
  min-height: 800px;
  background-color: #ffffff;
}

.service-qrcode {
  width: 120px;
  height: 144px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px rgba(128, 128, 128, 0.2);
  border-radius: 8px 0px 0px 8px;
  position: fixed;
  right: 0;
  bottom: 20%;
  text-align: center;
  z-index: 999999;
  cursor: pointer;
  transition-duration: 1s;

  .qrcode-wrap {
    display: inline-block;
    width: 96px;
    height: 96px;
    background: rgba(196, 196, 196, 1);
    margin-top: 12px;
  }

  p {
    color: rgba(128, 128, 128, 1);
    font-size: 12px;
    text-align: center;
    margin-top: 7px;
  }

  img {
    width: 96px;
    height: 96px;
    display: inline-block;
  }
}

.service-qrcode:hover {
  transform: scale(2);
  position: fixed;
  right: 100px;
  border-radius: 8px;
}


</style>
